<template>
  <q-list>
    <sticky-header static color="black">
      Filters
    </sticky-header>

    <template v-if="!!$slots['filters']">
      <slot name="filters" />

      <q-separator spaced inset />
    </template>

    <template v-if="showDefaultFilters">
      <q-item-wrapper v-if="showStatusFilter">
        <q-select
          v-model="formFilters.status"
          :options="templateStatusOptions"
          map-options
          emit-value
          outlined
          label="Status"
        />
      </q-item-wrapper>

      <q-item-wrapper tag="label">
        <q-checkbox
          v-model="formFilters.isMaster"
          label="Only Master Copies"
        />
      </q-item-wrapper>

      <q-item-wrapper
        v-if="can(permissions.canAccessBetaForms)"
        tag="label"
      >
        <q-checkbox
          v-model="formFilters.isBeta"
          label="Only Beta Templates"
        />
      </q-item-wrapper>
    </template>

    <transition name="slideTransition">
      <q-list v-if="categories.length > 0" key="categoryFilters">
        <q-separator
          v-if="showDefaultFilters"
          spaced
          inset
        />

        <q-item-wrapper
          caption="Selected Categories"
          dense
        />

        <CategoryItem
          v-for="category in categories"
          :key="'cat-' + category"
          :category="category"
          :selected="!isCategoryDisabledFunc(category)"
          :count="filteredResults.categories[category]"
          @click="$emit('toggle', category)"
        />
      </q-list>
    </transition>
  </q-list>
</template>

<script>
import CategoryItem from 'components/app/forms/partials/list/filters/CategoryItem.vue'

export default {
  components: {
    CategoryItem
  },
  props: {
    formFilters: {
      type: Object,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    filteredResults: {
      type: Object,
      required: true
    },
    isCategoryDisabledFunc: {
      type: Function,
      required: true
    },
    // Filter props
    showDefaultFilters: {
      type: Boolean,
      default: false
    },
    showStatusFilter: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle'],
  data () {
    return {
      templateStatusOptions: [
        { label: 'All Templates', value: null },
        { label: 'Draft', value: 'DRAFT' },
        { label: 'Published', value: 'VISIBLE' },
        { label: 'Update Available', value: 'UPDATE_PENDING' }
      ]
    }
  }
}
</script>
